<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <v-stage id="mapstage" :config="konva_stage">
    <v-layer>
      <v-image :config="image_object"></v-image>
      <v-line :config="vLine"></v-line>
      <v-image :config="bs_image_object"></v-image>
    </v-layer>
  </v-stage>
</template>

<script>
import BallonSonge from "./BallonSonge";
import Directions from "./direction";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      journey_coordonates: [
        [
          [20, 20],
          [100, 20],
          [100, 56],
          [100, 80],
          [180, 80],
          [180, 140],
          [150, 140],
          [150, 100],
          [20, 100]
        ],
        [
          [20, 20],
          [20, 50],
          [80, 50],
          [80, 130],
          [150, 130],
          [150, 60],
          [120, 60],
          [120, 30],
          [200, 30]
        ],
        [
          [20, 20],
          [20, 40],
          [50, 40],
          [50, 10],
          [80, 10],
          [80, 100],
          [50, 100],
          [50, 120],
          [140, 120],
          [140, 100],
          [100, 100],
          [100, 70],
          [180, 70],
          [180, 110],
          [200, 110],
          [200, 130],
          [140, 130],
          [140, 153]
        ]
      ],
      talkies: [["talkie_dariaerwin", "talkie_dialogue2"], ["talkie_dialogue1"], ["talkie_dialogue3"]],
      last_past_point: 0,
      bs: null,
      checkpoint_threshold: 0,
      angular_threshold: 0,
      konva_stage: {
        width: 216,
        height: 153
      },
      interval: null,
      talkies_played: [false, false, false],
      talkie_player_threshold: 0.1,
      has_played_search_game: false,
      speed: [450, 350, 250],
      image: null,
      bs_image: null,
      show_out_modal: false
    };
  },
  props: {
    tutorial: Boolean
  },
  created() {
    this.initBallonSonge();
    const image = new window.Image();
    image.src = "https://cdn.exploreve.fr/content/IM3/images/jeu_ballon/interfaces/support_carte_v1.svg";
    image.style.maxWidth = "100%";
    image.onload = () => {
      this.image = image;
    };
    const bs_image = new window.Image();
    bs_image.src = "https://cdn.exploreve.fr/content/ballons/ballon_rose.svg";
    bs_image.width = 10;
    bs_image.height = 20;
    bs_image.onload = () => {
      this.bs_image = bs_image;
    };
  },
  mounted() {
    const k = document.getElementById("mapstage");
    k.style.width = "100%";
    k.style.height = "100%";
    const content = k.getElementsByClassName("konvajs-content")[0];
    content.style.width = "100%";
    content.style.height = "100%";
    const items = content.getElementsByTagName("canvas");
    for (let i = 0; i < items.length; ++i) {
      items.item(i).style.width = "100%";
      items.item(i).style.height = "100%";
    }
  },
  computed: {
    ...mapGetters(["game_state"], "game_state"),
    ...mapGetters(["current_stage"], "current_stage"),
    ...mapGetters(["current_direction"], "current_direction"),
    vLine() {
      return {
        x: 0,
        y: 0,
        points: this.journey_coordonates[this.current_stage].flat(),
        tension: 0.1,
        stroke: "#CD8C31",
        strokeWidth: 6
      };
    },
    image_object() {
      return {
        width: this.konva_stage.width,
        height: this.konva_stage.height,
        image: this.image
      };
    },
    bs_image_object() {
      return {
        x: this.bs.x - 5,
        y: this.bs.y - 10,
        visible: true,
        image: this.bs_image
      };
    }
  },
  watch: {
    game_state: function (value) {
      if (value === "PLAY") {
        this.resume();
      }
    }
  },
  methods: {
    resume() {
      if (!this.tutorial) {
        this.playTalkies();
        if (!this.interval) {
          this.interval = setInterval(() => {
            let curdir = this.current_direction ?? -1;
            if (curdir !== -1) {
              this.$emit("newdir", this.current_direction);
              switch (this.current_direction) {
                case Directions.NORTH:
                  this.bs.moveUp();
                  break;
                case Directions.EAST:
                  this.bs.moveRight();
                  break;
                case Directions.SOUTH:
                  this.bs.moveDown();
                  break;
                case Directions.WEST:
                  this.bs.moveLeft();
                  break;
              }

              const pos1 = this.journey_coordonates[this.current_stage][this.last_past_point];
              const pos2 = this.journey_coordonates[this.current_stage][this.last_past_point + 1];

              if (this.bs.isOutOfTrajectory(pos1, pos2)) {
                this.bs.projectBallonInTrajectory(pos1, pos2);
              }
              // if (this.current_stage === 3 && this.last_past_point === 7) {
              //   setTimeout(() => {
              //     this.$store.dispatch("setMessagePreRead", true);
              //   }, Math.floor(Math.random() * 20));
              // }
              if (this.bs.compareTo(pos1, pos2)) {
                this.last_past_point++;
              }
              if (this.last_past_point === this.journey_coordonates[this.current_stage].length - 1) {
                this.finished();
              }
            }
          }, this.speed[this.current_stage]);
        }
      }
    },
    stopMouvement() {
      clearInterval(this.interval);
      this.interval = null;
    },
    finished() {
      this.stopMouvement();
      this.last_past_point = 0;
      this.has_played_search_game = false;
      if (this.current_stage + 1 < this.journey_coordonates.length) {
        this.$store.dispatch("changeState", "FINISHED");
        this.initBallonSonge();
      } else {
        this.$store.dispatch("changeState", "FINISHED_LAST");
      }
    },
    // hideFallModal() {
    //   if (!this.has_played_search_game) {
    //     this.has_played_search_game = true;
    //     this.$store.dispatch("changeState", "FALLOUT");
    //   } else {
    //     this.$store.dispatch("changeState", "PLAY");
    //   }
    // },
    playTalkies() {
      if (!this.talkies_played[this.current_stage]) {
        this.talkies_played[this.current_stage] = true;
        this.talkies[this.current_stage].reduce((acc, talkie_id) => {
          if (acc === null) {
            acc = Promise.resolve(1);
          }
          return acc.then(() => {
            return new Promise((resolve) => {
              setTimeout(() => {
                this.$emit("talkie", { talkie_id: talkie_id, on_end: () => resolve(1) });
              }, 15000 + Math.floor(Math.random() * 10000));
            });
          });
        }, null);
      }
    },
    initBallonSonge() {
      this.bs = new BallonSonge(20, 20);
    }
  }
};
</script>
<style lang="scss" scoped>
#mapstage {
  width: 100%;
  height: 100%;
}
.konvajs-content {
  width: 100%;
  height: 100%;

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
